

















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  data() {
    return {
      emailsText: '',
    };
  },
  computed: {
    ...mapGetters('user', ['teacherInviteEmailsQuota']),
  },
  methods: {
    getParsedEmails() {
      return this.emailsText.trim().split(/\s+/);
    },
    async sendInvitationEmails() {
      try {
        const emailList = this.getParsedEmails();
        const dispatchPromise = await this.$store.dispatch(
          'studio/sendInvitationEmails',
          emailList
        );
        await this.$store.dispatch('user/loadUserInfo');
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.EMAIL_LIST_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.EMAIL_LIST_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
});
